import { useState } from 'react';
import { Typography, Button, Space, Tooltip, message } from 'antd';
import { CopyOutlined, ExpandOutlined, CompressOutlined } from '@ant-design/icons';

const { Text } = Typography;

interface JsonViewerProps {
  data: string | object;
  maxHeight?: number;
  defaultExpanded?: boolean;
}

export function JsonViewer({ data, maxHeight = 300, defaultExpanded = false }: JsonViewerProps) {
  const [expanded, setExpanded] = useState(defaultExpanded);

  // Parse if string
  let parsed: object;
  let isValid = true;

  try {
    parsed = typeof data === 'string' ? JSON.parse(data) : data;
  } catch {
    isValid = false;
    parsed = {};
  }

  const formatted = isValid ? JSON.stringify(parsed, null, 2) : String(data);
  const compact = isValid ? JSON.stringify(parsed) : String(data);

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(formatted);
      message.success('Kopyalandı');
    } catch {
      message.error('Kopyalanamadı');
    }
  };

  const displayText = expanded ? formatted : compact;
  const needsTruncation = !expanded && compact.length > 100;
  const truncatedText = needsTruncation ? compact.slice(0, 100) + '...' : displayText;

  return (
    <div>
      <div style={{ marginBottom: 8 }}>
        <Space size="small">
          <Tooltip title={expanded ? 'Daralt' : 'Genişlet'}>
            <Button
              type="text"
              size="small"
              icon={expanded ? <CompressOutlined /> : <ExpandOutlined />}
              onClick={() => setExpanded(!expanded)}
            />
          </Tooltip>
          <Tooltip title="Kopyala">
            <Button
              type="text"
              size="small"
              icon={<CopyOutlined />}
              onClick={copyToClipboard}
            />
          </Tooltip>
          {!isValid && (
            <Text type="warning" style={{ fontSize: 12 }}>Geçersiz JSON</Text>
          )}
        </Space>
      </div>
      <pre
        style={{
          background: '#f5f5f5',
          padding: 12,
          borderRadius: 4,
          overflow: 'auto',
          maxHeight: expanded ? maxHeight : 'auto',
          fontSize: 12,
          fontFamily: 'monospace',
          margin: 0,
          whiteSpace: expanded ? 'pre' : 'nowrap',
          textOverflow: expanded ? 'unset' : 'ellipsis',
        }}
      >
        {expanded ? formatted : truncatedText}
      </pre>
    </div>
  );
}
